// A single source of truth for every REST path. Prevents typo'd URL
// strings scattered across feature files and makes path changes a
// one-line edit.
export const endpoints = {
  auth: {
    login: '/auth/login',
    refresh: '/auth/refresh',
    logout: '/auth/logout',
    me: '/auth/me',
  },
  documents: {
    list: '/documents',
    detail: (id: number) => `/documents/${id}`,
    create: '/documents',
    versions: (id: number) => `/documents/${id}/versions`,
    download: (id: number, versionId: number) => `/documents/${id}/versions/${versionId}/download`,
    tags: (id: number) => `/documents/${id}/tags`,
    comments: (id: number) => `/documents/${id}/comments`,
  },
  folders: {
    tree: '/folders/tree',
    detail: (id: number) => `/folders/${id}`,
  },
  approvals: {
    forDocument: (documentId: number) => `/documents/${documentId}/approvals`,
    action: (approvalId: number) => `/approvals/${approvalId}/actions`,
    pendingForMe: '/approvals/pending',
  },
  notifications: {
    list: '/notifications',
    markRead: (id: number) => `/notifications/${id}/read`,
  },
  dashboard: {
    stats: '/dashboard/stats',
    activity: '/dashboard/activity',
  },
} as const;
